import moment from 'moment'

const customFunctions = {
  setPhoneNumber(phone_code, phone) {
    if (!phone) {
      return ''
    }

    if (
      phone_code !== '' &&
      phone_code !== null &&
      phone_code.startsWith('+') === false
    ) {
      phone_code = '+' + phone_code
    }
    return (
      (phone_code !== null ? phone_code : '') +
      ' ' +
      (phone !== null ? phone : '-')
    )
  },
  moneyFix(val, pieceCount) {
    if (val) {
      val = parseFloat(val)
      if (val > 0) {
        val = val.toFixed(pieceCount).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    }
    return '-'
  },
  /* 
    let date = '2021-05-30T11:34:56+03:00'
    let utcOffset = '+04:00'
  */
  setMomentWithFormat(date, format, utcOffset) {
    if (date) {
      if (!utcOffset) {
        //control utcOffset
        if (date.includes('+')) {
          var splt = date.split('+')
          utcOffset = `+${splt[1]}`
        }
      }

      if (!format) {
        format = 'L LT'
      }

      if (utcOffset) {
        return moment(date).utcOffset(utcOffset).format(format)
      }
      return moment(date).format(format)
    } else return '-'
  },
  upperFirstLetter(value) {
    return value.replace(/\b\w/g, (c) => c.toUpperCase())
  },
  convertMBtoGB(value) {
    return Math.floor(value / 1024)
  },
  convertMBtoGBWithHalfPoint(value) {
    let convertGB = value / 1024
    //512 x karşılığı 0.5 olduğu için ona uygun çeviriyorum
    return Math.round(convertGB * 2) / 2
  },
  convertGBtoMB(value) {
    return value * 1024
  },
  dateFormatEpoc(value, format) {
    var utcSeconds = value
    var d = new Date(0) // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(utcSeconds)
    return moment(d).format(format)
  },
  controlUrlAddFirstSplash(value) {
    return value.startsWith('/') ? value : `/${value}`
  },
  controlUrlRemoveFirstSplash(value) {
    return value.startsWith('/') ? value.slice(1) : value
  },
  capitalizeFirstLetter(value) {
    if (value) return value.charAt(0).toUpperCase() + value.slice(1)
    else return ''
  },
  splitContent(val, number) {
    if (val && val.length > number) {
      return val.substring(0, number) + '..'
    }

    return val
  },
  splitHtml(value, number) {
    let newContent = value.replace(/<br\s*\/?>/gi, '##')
    newContent = newContent.replace(/<p\s*\/?>/gi, '##')
    newContent = newContent.replace(/<\/?[^>]+>/gi, ' ')

    if (newContent.startsWith('##')) {
      newContent = newContent.substring(2, newContent.length)
    }

    newContent = newContent.replace(/##/g, '<br />')
    newContent = newContent.trim()

    if (newContent.length > number) return newContent.slice(0, number) + '...'
    else return newContent
  },
  controlSpace(value) {
    let lengthValue = 20
    if (value && value.length > lengthValue) {
      let newValue = ''

      let dotList = value.split('.')
      if (dotList.length > 0) {
        let _new = ''
        dotList.forEach(function (item) {
          _new += value.length + item > lengthValue ? `${item}. ` : `${item}.`
        })
        value = _new.slice(0, -1)
      }

      value.split(' ').forEach(function (item) {
        if (item.length > lengthValue) {
          for (
            let index = 0;
            index < Math.ceil(item.length / lengthValue);
            index++
          ) {
            newValue += `${item.substr(
              index * lengthValue,
              (index == 0 ? 1 : index) * lengthValue
            )} `
          }
        } else newValue += `${item} `
      })
      return newValue
    }
    return value
  },
}

export default customFunctions
